import * as React from "react";
import { CardType } from "../../../../data";

export class MainHeading extends React.PureComponent<{
    cardType: CardType
}, {}> {

    render() {
        return (
            <h3 className={`rj-ev-list__main-heading ${`rj-ev-list__main-heading--${this.props.cardType.toLowerCase()}`}`} data-uat="h3-ev-list-main-heading">
                {this.props.children}
            </h3>
        )
    }
}